import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Chip from '@mui/joy/Chip';
import Typography from '@mui/joy/Typography';
import Divider from '@mui/joy/Divider';
import Card from '@mui/joy/Card';
import Button from '@mui/joy/Button';

import UserAPI from "api/user";

import useSubscription from 'hooks/useSubscription';
import { BACKGROUND_GRADIENT_CSS } from '../constants';

import { Success, Error } from 'components/FancyToast';

function StripeComplete() {
    const { checkoutSessionId } = useParams();
    const { syncCheckoutSession } = useSubscription();
    const [status, setStatus] = useState('loading');
    const [email, setEmail] = useState('');
    const [count, setCount] = useState(0);
    const [clicked, setClicked] = useState(false);

    function startPasswordReset() {
        if(clicked) return;
        setClicked(true);
		UserAPI.passwordStartUpdate(email)
			.then((d) => {
                console.log(d);
				// navigate to login
				Success("Great! Check your email for a link to set your password");
			}).catch((err) => {
                console.error(err);
                if(err.message == 'throttled') {
				    Error("Please wait a minute before trying again.");
                }
                else {
				    Error("There was a problem.");
                }
			});
    }

    function syncSession() {
        if (!checkoutSessionId) {
            return;
        }
        syncCheckoutSession(checkoutSessionId)
            .then((k) => {
                if(count > 10) {
                    setStatus('error');
                    return;
                }
                if(!k || (k && !k.uuid)) {
                    setCount(count + 1);
                    setTimeout(syncSession, ((count + 1) * 750));
                    setStatus('waiting');
                    return;
                }
                else {
                    setEmail(k.primary_email);
                    setStatus('success');
                }
            })
            .catch(() => {
                Error("There was an error.");
            });
    }

    useEffect(() => {
        if (!checkoutSessionId) {
            return;
        }
        syncSession();
    }, [checkoutSessionId]);

    return (

      <Stack
            width={"100vw"}
            height={"100vh"}
            direction="column"
            justifyContent="flex-start"
            // pt={5}
            alignItems="center"
            sx={{
                backgroundImage: BACKGROUND_GRADIENT_CSS,
                overflow: "auto"
            }}
        >
          <Card variant="outlined"
                id="some-id"
                sx={{
                    maxWidth: 550,
                    m: 'auto'
                }}
            >
            { status == "success" &&
                <Stack spacing={2.5}>
                    <Stack>
                    <Typography level="title-lg">Payment Successful!</Typography>
                        <Typography level="title-sm">
                            We're excited (and ready) to get started.
                        </Typography>
                    </Stack>

                    { clicked &&
                    <Stack>
                        <Typography>We emailed you a link to setup your password.</Typography>
                        <Typography level="body-xs">We sent it to <Chip variant="outlined">{ email }</Chip> </Typography>
                    </Stack>
                    }

                    { !clicked &&
                        <Stack spacing={2}>
                            <Typography>Before we get started, you'll need a password.</Typography>
                            <Button
                                onClick={() => startPasswordReset()}>
                                Email Password Link
                            </Button>
                        </Stack>
                    }


                    <Divider />
                    <Typography level="body-xs">
                        If you need a hand with this, email our founder: tedroden@fancyhands.com
                    </Typography>
                </Stack>
            }
            { status == "loading" &&
                <Stack>
                    <Typography level="title-lg">Loading</Typography>
                    <p>Loading payment information.</p>
                </Stack>
            }
            { status == "waiting" &&
                <Stack>
                    <Typography level="title-lg">Payment Pending</Typography>
                    <p>Your payment is being processed. This shouldn't take long.</p>
                </Stack>
            }
            { status == "error" &&
                <Stack spacing={2}>
                    <Typography level="title-lg">Hrm</Typography>
                    <Typography>There was an issue</Typography>
                    <Typography level="body-md">Email our founder: tedroden@fancyhands.com, he cares about stuff like this. </Typography>

                </Stack>
            }
        </Card>
      </Stack>

    );

}
export default StripeComplete;
